var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"assessment-light"},[_c('v-card-text',{staticClass:"subtitle-1 assessment-light"},[_c('mrx-translation',{attrs:{"token":_vm.prompt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }